export { default } from "bullitttime-embermodelsgochips/serializers/application";
